export enum ModalId {
  Account,
  Activation,
  AddCoApplicant,
  AppraisalRefresh,
  FilterMenu,
  GeicoDiscount,
  Geolocation,
  GreatDeal,
  MoreDetails,
  Review,
  RootDiscount,
  SampleTermsModal,
  SaveSearchModal,
  SaveSearchNudge,
  SearchBar,
  Shipping,
  SoftPull,
  SortBy,
  TradeIncentive,
  WIPNotifications
}

export const ModalPriorities = {
  [ModalId.Account]: 3,
  [ModalId.AppraisalRefresh]: 1,
  [ModalId.GeicoDiscount]: 1,
  [ModalId.RootDiscount]: 1,
  [ModalId.SaveSearchModal]: 1,
  [ModalId.Shipping]: 2,
  [ModalId.TradeIncentive]: 2,
  [ModalId.SampleTermsModal]: 2,
  [ModalId.SoftPull]: 1
};

export enum NativeModalId {
  Geolocation = 'geolocation',
  SoftPull = 'softPull'
}
